import create from "zustand";
import { logout, refreshToken } from "../api/AuthRequest";
import { getDeviceInfo } from "../components/firebase/firebaseConfig";

const useAuthStore = create((set, get) => ({
  user: null,
  refToken: null,
  isAuthenticated: false,
  authType: "login",
  authModal: false,
  loading: false,
  error: null,
  userType: "",
  fcmToken: null,


  loginCall: async (data) => {
    try {
      set({
        user: data?.user,
        refToken: data.refreshToken,
        isAuthenticated: true,
        authModal: false,
        loading: false,
        error: null,
        userType: data?.user?.role,
      });
      await localStorage.setItem("refToken", data.refreshToken);
    } catch (error) {
      //  loginSocketConnection();

      console.error("Login Call error:", error);
      set({
        user: null,
        isAuthenticated: false,
        loading: false,
        error:
          error.response?.data.message || "An error occurred during login.",
      });
    }
  },

  logout: async (token) => {
    try {
      const { fcmToken } = get()
      const deviceInfo = await getDeviceInfo()
      // console.log(deviceInfo, 'deviceInfo');

      const details = {
        refToken: token,
        deviceInfo: deviceInfo,
        fcmToken: fcmToken
      }

      const { data } = await logout(details);

      if (data?.success) {
        set({
          refToken: null,
          user: null,
          isAuthenticated: false,
          loading: false,
          error: null,
          fcmToken: null,
        });
        localStorage.clear();
      } else {
        // Even if the server response indicates failure, clear client-side data
        set({
          surveyorRefToken: null,
          user: null,
          adminRefToken: null,
          isAuthenticated: false,
          loading: false,
          error: null,
          fcmToken: null,
        });
        localStorage.clear();
      }
    } catch (error) {
      set({
        surveyorRefToken: null,
        user: null,
        adminRefToken: null,
        isAuthenticated: false,
        loading: false,
        error: null,
        fcmToken: null,
      });
      localStorage.clear();
    }
  },
  refreshToken: async (token) => {
    try {
      const { data } = await refreshToken(token);
      if (data?.success) {
        if (data?.user) {
          set({
            adminRefToken: data.refreshToken,
          });
        }
      } else {
        set({
          user: null,
          isAuthenticated: false,
          adminRefToken: null,
          branchRefToken: null,
        });
      }
    } catch (error) {
      console.error("Refresh Token error:", error);
      localStorage.clear();
    }
  },

  updateUser: async (updateduser) => {

    set({
      user: updateduser,
    });
  },

  updateFcmToken: async (token) => {
    console.log("got token");

    set({
      fcmToken: token,
    });
  },

}));

// Hydrate the store with data from localStorage on creation
const storedAuthState = JSON.parse(localStorage.getItem("authState")) || {};
useAuthStore.setState(storedAuthState);

// Subscribe to state changes and persist the state to localStorage
useAuthStore.subscribe((state) => {
  localStorage.setItem("authState", JSON.stringify(state));
});

export default useAuthStore;
